{
  "familyId": "TIJD-SNELHEID",
  "questions": [
    {
      "id": "TIJD-SNELHEID-001",
      "familyId": "TIJD-SNELHEID",
      "module": "Tijd",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "snelheid",
      "subSkill": "snelheid_berekenen",
      "questionType": "fill_in",
      "question": "Een ambulancechauffeur rijdt 90 km in 1 uur en 30 minuten. Bereken de gemiddelde snelheid in km/u.",
      "data": {
        "acceptedAnswers": ["60", "60 km/u"],
        "unit": "km/u",
        "placeholder": "... km/u"
      },
      "correctAnswer": "60",
      "conceptId": "speed_basic_minutes",
      "variantIndex": 1,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "stimulusAids": [
        {
          "type": "numberline",
          "showWhen": "always",
          "data": {
            "start": 0, "end": 90, "step": 15,
            "markers": [
              { "value": 0, "label": "Start" },
              { "value": 30, "label": "30 min" },
              { "value": 60, "label": "60 min" },
              { "value": 90, "label": "90 min\n(1,5 uur)" }
            ],
            "label": "Afstand (km) over de tijd"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule", "showWhen": "wrong",
          "data": {
            "title": "AST-driehoek: Snelheid berekenen",
            "content": "Gebruik de AST-driehoek: Afstand = Snelheid × Tijd. Dus Snelheid = Afstand ÷ Tijd. Let op: reken de tijd eerst om naar uren. 1 uur en 30 minuten = 1,5 uur. Dan: 90 km ÷ 1,5 uur = 60 km/u.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "De ambulancechauffeur wil weten hoe snel hij gemiddeld reed. Snelheid bereken je met de AST-driehoek: Snelheid = Afstand ÷ Tijd. Eerst reken je de tijd om: 1 uur en 30 minuten = 1,5 uur. Dan deel je: 90 km ÷ 1,5 uur = 60 km/u. Controleer: 60 km/u × 1,5 uur = 90 km ✓. De ambulance reed gemiddeld 60 km/u.",
        "solutionSteps": [
          "Schrijf de gegevens op: afstand = 90 km, tijd = 1 uur en 30 minuten",
          "Reken de tijd om naar uren: 1 uur en 30 min = 1,5 uur",
          "Gebruik de formule: snelheid = afstand ÷ tijd",
          "Reken uit: 90 ÷ 1,5 = 60 km/u",
          "Controleer: 60 × 1,5 = 90 km ✓"
        ],
        "distractorExplanations": {}
      }
    },
    {
      "id": "TIJD-SNELHEID-002",
      "familyId": "TIJD-SNELHEID",
      "module": "Tijd",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "snelheid",
      "subSkill": "snelheid_berekenen",
      "questionType": "multiple_choice",
      "question": "Een pakketbezorger fietst met 18 km/u. Hoe ver komt ze in 2,5 uur?",
      "options": ["45 km", "7,2 km", "20,5 km", "36 km"],
      "correctAnswer": 0,
      "conceptId": "distance_from_speed",
      "variantIndex": 2,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.71,
      "stimulusAids": [
        {
          "type": "numberline", "showWhen": "always",
          "data": {
            "start": 0, "end": 54, "step": 18,
            "markers": [
              { "value": 0, "label": "0 uur" },
              { "value": 18, "label": "1 uur\n18 km" },
              { "value": 36, "label": "2 uur\n36 km" },
              { "value": 54, "label": "3 uur\n54 km" }
            ],
            "label": "Afstand bij 18 km/u"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule", "showWhen": "wrong",
          "data": {
            "title": "AST-driehoek: Afstand berekenen",
            "content": "Afstand = Snelheid × Tijd. De pakketbezorger fietst 18 km per uur. In 2,5 uur: 18 × 2,5 = 45 km. Tip: reken 18 × 2 = 36 en 18 × 0,5 = 9. Samen: 36 + 9 = 45 km.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "De pakketbezorger wil weten hoe ver ze komt. Afstand bereken je met: Afstand = Snelheid × Tijd. Ze fietst 18 km/u en is 2,5 uur onderweg. Dus: 18 × 2,5 = 45 km. Een handige rekenstrategie: splits 2,5 in 2 + 0,5. Dan: 18 × 2 = 36 km en 18 × 0,5 = 9 km. Samen: 36 + 9 = 45 km. Controleer: 45 km ÷ 2,5 uur = 18 km/u ✓.",
        "solutionSteps": [
          "Schrijf de gegevens op: snelheid = 18 km/u, tijd = 2,5 uur",
          "Gebruik de formule: afstand = snelheid × tijd",
          "Splits de berekening: 18 × 2 = 36 en 18 × 0,5 = 9",
          "Tel op: 36 + 9 = 45 km",
          "Controleer: 45 ÷ 2,5 = 18 km/u ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 18 × 2,5 = 45 km. Je hebt de AST-driehoek correct toegepast: Afstand = Snelheid × Tijd.",
          "1": "Je dacht waarschijnlijk dat je de snelheid door de tijd moet delen: 18 ÷ 2,5 = 7,2. Maar bij afstand berekenen vermenigvuldig je juist: Afstand = Snelheid × Tijd. Onthoud de AST-driehoek: de A staat bovenaan, dus A = S × T.",
          "2": "Je dacht waarschijnlijk dat je de snelheid en tijd moet optellen: 18 + 2,5 = 20,5. Maar km/u en uren kun je niet optellen — het zijn verschillende eenheden. Onthoud: Afstand = Snelheid × Tijd = 18 × 2,5 = 45 km.",
          "3": "Je hebt waarschijnlijk 18 × 2 = 36 gerekend, maar bent vergeten dat het 2,5 uur is (niet 2 uur). Het halve uur telt ook mee: 18 × 0,5 = 9 km extra. Totaal: 36 + 9 = 45 km."
        }
      }
    },
    {
      "id": "TIJD-SNELHEID-003",
      "familyId": "TIJD-SNELHEID",
      "module": "Tijd",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "snelheid",
      "subSkill": "snelheid_berekenen",
      "questionType": "multiple_choice",
      "question": "Een taxichauffeur rijdt 84 km in 1 uur en 12 minuten. Wat is de gemiddelde snelheid?",
      "options": ["70 km/u", "84 km/u", "72 km/u", "42 km/u"],
      "correctAnswer": 0,
      "conceptId": "speed_minutes_conversion",
      "variantIndex": 3,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.70,
      "stimulusAids": [
        {
          "type": "numberline", "showWhen": "always",
          "data": {
            "start": 0, "end": 84, "step": 14,
            "markers": [
              { "value": 0, "label": "Start" },
              { "value": 84, "label": "84 km\n(1u 12min)" }
            ],
            "label": "Route taxichauffeur"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule", "showWhen": "wrong",
          "data": {
            "title": "Minuten omrekenen naar uren",
            "content": "Reken eerst de minuten om: 12 minuten = 12/60 = 0,2 uur. Dus 1 uur en 12 minuten = 1,2 uur. Dan: snelheid = 84 ÷ 1,2 = 70 km/u. Tip: 12 minuten is 1/5 van een uur.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "De taxichauffeur wil zijn gemiddelde snelheid weten. Eerst reken je de minuten om naar uren: 12 minuten = 12 ÷ 60 = 0,2 uur. Dus de totale tijd is 1,2 uur. Dan gebruik je de formule: Snelheid = Afstand ÷ Tijd = 84 ÷ 1,2 = 70 km/u. Controleer: 70 × 1,2 = 84 km ✓. Tip: 12 minuten is precies 1/5 van een uur, dus je kunt ook rekenen: 84 ÷ 6/5 = 84 × 5/6 = 70.",
        "solutionSteps": [
          "Schrijf de gegevens op: afstand = 84 km, tijd = 1 uur en 12 minuten",
          "Reken minuten om: 12 min ÷ 60 = 0,2 uur → totaal 1,2 uur",
          "Gebruik de formule: snelheid = afstand ÷ tijd",
          "Reken uit: 84 ÷ 1,2 = 70 km/u",
          "Controleer: 70 × 1,2 = 84 km ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 12 minuten = 0,2 uur, dus de totale tijd is 1,2 uur. Snelheid = 84 ÷ 1,2 = 70 km/u.",
          "1": "Je dacht waarschijnlijk dat de snelheid gelijk is aan de afstand: 84 km/u. Maar je moet de afstand nog delen door de tijd. De chauffeur deed er 1,2 uur over, dus: 84 ÷ 1,2 = 70 km/u. Onthoud: snelheid ≠ afstand.",
          "2": "Je dacht waarschijnlijk dat 12 minuten = 0,12 uur is, en rekende 84 ÷ 1,12 ≈ 72. Maar 12 minuten = 12/60 = 0,2 uur (niet 0,12). Onthoud: om minuten naar uren om te rekenen, deel je door 60.",
          "3": "Je dacht waarschijnlijk dat je door 2 moet delen: 84 ÷ 2 = 42. Maar de tijd is 1,2 uur, niet 2 uur. Onthoud: reken de minuten eerst om: 1 uur en 12 min = 1,2 uur."
        }
      }
    },
    {
      "id": "TIJD-SNELHEID-004",
      "familyId": "TIJD-SNELHEID",
      "module": "Tijd",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "snelheid",
      "subSkill": "snelheid_berekenen",
      "questionType": "fill_in",
      "question": "Een hardloper rent met 12 km/u. Hoeveel minuten doet ze over 6 km?",
      "data": {
        "acceptedAnswers": ["30", "30 minuten", "30 min"],
        "unit": "minuten",
        "placeholder": "... minuten"
      },
      "correctAnswer": "30",
      "conceptId": "time_from_speed_minutes",
      "variantIndex": 4,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.70,
      "stimulusAids": [
        {
          "type": "numberline", "showWhen": "always",
          "data": {
            "start": 0, "end": 12, "step": 3,
            "markers": [
              { "value": 0, "label": "Start" },
              { "value": 6, "label": "6 km\n(? min)" },
              { "value": 12, "label": "12 km\n(60 min)" }
            ],
            "label": "Route hardloper (12 km/u)"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule", "showWhen": "wrong",
          "data": {
            "title": "AST-driehoek: Tijd berekenen",
            "content": "Tijd = Afstand ÷ Snelheid = 6 ÷ 12 = 0,5 uur. Reken om naar minuten: 0,5 × 60 = 30 minuten. Tip: 6 km is de helft van 12 km, dus het duurt een half uur.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "De hardloper wil weten hoeveel minuten ze over 6 km doet. Tijd = Afstand ÷ Snelheid = 6 km ÷ 12 km/u = 0,5 uur. Nu reken je om naar minuten: 0,5 × 60 = 30 minuten. Je kunt het ook zo bedenken: bij 12 km/u loopt ze 12 km in 60 minuten. 6 km is de helft, dus dat duurt de helft van 60 = 30 minuten. Controleer: 12 km/u × 0,5 uur = 6 km ✓.",
        "solutionSteps": [
          "Schrijf de gegevens op: snelheid = 12 km/u, afstand = 6 km",
          "Gebruik de formule: tijd = afstand ÷ snelheid",
          "Reken uit: 6 ÷ 12 = 0,5 uur",
          "Reken om naar minuten: 0,5 × 60 = 30 minuten",
          "Controleer: 12 × 0,5 = 6 km ✓"
        ],
        "distractorExplanations": {}
      }
    },
    {
      "id": "TIJD-SNELHEID-005",
      "familyId": "TIJD-SNELHEID",
      "module": "Tijd",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "snelheid",
      "subSkill": "snelheid_berekenen",
      "questionType": "multiple_choice",
      "question": "Een vrachtwagenchauffeur rijdt 240 km in 3 uur. Daarna rijdt hij nog 80 km in 1 uur. Wat is de gemiddelde snelheid over de hele rit?",
      "options": ["80 km/u", "160 km/u", "106,7 km/u", "90 km/u"],
      "correctAnswer": 0,
      "conceptId": "speed_two_segments",
      "variantIndex": 5,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.69,
      "stimulusAids": [
        {
          "type": "numberline", "showWhen": "always",
          "data": {
            "start": 0, "end": 320, "step": 80,
            "markers": [
              { "value": 0, "label": "Start" },
              { "value": 240, "label": "240 km\n(3 uur)" },
              { "value": 320, "label": "320 km\n(4 uur)" }
            ],
            "label": "Route vrachtwagenchauffeur"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule", "showWhen": "wrong",
          "data": {
            "title": "Gemiddelde snelheid over meerdere stukken",
            "content": "Bij gemiddelde snelheid tel je ALLE kilometers op en deel je door ALLE uren. Totale afstand: 240 + 80 = 320 km. Totale tijd: 3 + 1 = 4 uur. Gemiddelde snelheid = 320 ÷ 4 = 80 km/u. Let op: je mag NIET de twee snelheden middelen!",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "De vrachtwagenchauffeur wil zijn gemiddelde snelheid weten. Bij meerdere stukken tel je eerst alles bij elkaar op. Totale afstand: 240 + 80 = 320 km. Totale tijd: 3 + 1 = 4 uur. Gemiddelde snelheid = totale afstand ÷ totale tijd = 320 ÷ 4 = 80 km/u. Let op: je mag NIET de twee snelheden middelen (80 en 80 toevallig hetzelfde, maar de methode is belangrijk). Controleer: 80 km/u × 4 uur = 320 km ✓.",
        "solutionSteps": [
          "Tel de afstanden op: 240 + 80 = 320 km",
          "Tel de tijden op: 3 + 1 = 4 uur",
          "Gebruik de formule: gemiddelde snelheid = totale afstand ÷ totale tijd",
          "Reken uit: 320 ÷ 4 = 80 km/u",
          "Controleer: 80 × 4 = 320 km ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Totale afstand = 320 km, totale tijd = 4 uur. Gemiddelde snelheid = 320 ÷ 4 = 80 km/u.",
          "1": "Je dacht waarschijnlijk dat je de twee afstanden moet vermenigvuldigen of de snelheden optellen. Maar gemiddelde snelheid = totale afstand ÷ totale tijd. Onthoud: tel alles op en deel dan.",
          "2": "Je dacht waarschijnlijk dat je de snelheden van de twee stukken apart berekent en dan middelt: (80 + 80) ÷ 2 = 80. Hier klopt dat toevallig, maar de juiste methode is: totale afstand ÷ totale tijd. Bij ongelijke tijden geeft middelen een fout antwoord!",
          "3": "Je dacht waarschijnlijk dat de gemiddelde snelheid 90 km/u is. Misschien heb je 320 ÷ 3,5 gerekend? Maar de totale tijd is 3 + 1 = 4 uur, niet 3,5. Onthoud: tel beide tijden op."
        }
      }
    },
    {
      "id": "TIJD-SNELHEID-006",
      "familyId": "TIJD-SNELHEID",
      "module": "Tijd",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "snelheid",
      "subSkill": "snelheid_berekenen",
      "questionType": "multiple_choice",
      "question": "Een vliegtuig legt 900 km af in 1,5 uur. Wat is de gemiddelde snelheid?",
      "options": ["600 km/u", "1350 km/u", "450 km/u", "300 km/u"],
      "correctAnswer": 0,
      "conceptId": "speed_large_numbers",
      "variantIndex": 6,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.70,
      "stimulusAids": [
        {
          "type": "numberline", "showWhen": "always",
          "data": {
            "start": 0, "end": 900, "step": 300,
            "markers": [
              { "value": 0, "label": "Start" },
              { "value": 300, "label": "0,5 uur" },
              { "value": 600, "label": "1 uur" },
              { "value": 900, "label": "1,5 uur\n900 km" }
            ],
            "label": "Afstand vliegtuig over de tijd"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule", "showWhen": "wrong",
          "data": {
            "title": "Delen door een kommagetal",
            "content": "Snelheid = 900 ÷ 1,5. Tip: maak er hele getallen van door beide × 2: 1800 ÷ 3 = 600 km/u. Of: 900 ÷ 1,5 → 1,5 uur = 3 halve uren. 900 ÷ 3 = 300 per half uur = 600 per uur.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Het vliegtuig legt 900 km af in 1,5 uur. Snelheid = Afstand ÷ Tijd = 900 ÷ 1,5 = 600 km/u. Een handige truc bij delen door 1,5: vermenigvuldig boven en onder met 2. Dan wordt het 1800 ÷ 3 = 600. Of bedenk: in een half uur legt het vliegtuig 900 ÷ 3 = 300 km af, dus in een heel uur 600 km. Controleer: 600 × 1,5 = 900 km ✓.",
        "solutionSteps": [
          "Schrijf de gegevens op: afstand = 900 km, tijd = 1,5 uur",
          "Gebruik de formule: snelheid = afstand ÷ tijd",
          "Reken uit: 900 ÷ 1,5 = 600 km/u (tip: × 2 → 1800 ÷ 3 = 600)",
          "Controleer: 600 × 1,5 = 900 km ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 900 ÷ 1,5 = 600 km/u. Het vliegtuig vliegt gemiddeld 600 kilometer per uur.",
          "1": "Je dacht waarschijnlijk dat je moet vermenigvuldigen: 900 × 1,5 = 1350. Maar bij snelheid berekenen DEEL je de afstand door de tijd. Onthoud de AST-driehoek: Snelheid = Afstand ÷ Tijd.",
          "2": "Je dacht waarschijnlijk dat je door 2 moet delen: 900 ÷ 2 = 450. Maar de tijd is 1,5 uur, niet 2 uur. Onthoud: gebruik de exacte tijd. 900 ÷ 1,5 = 600 km/u.",
          "3": "Je dacht waarschijnlijk dat je door 3 moet delen: 900 ÷ 3 = 300. Maar 1,5 uur is niet 3 uur. Misschien verwarde je 1,5 uur met 3 halve uren? Per half uur is het 300 km, maar per heel uur is het 600 km/u."
        }
      }
    },
    {
      "id": "TIJD-SNELHEID-007",
      "familyId": "TIJD-SNELHEID",
      "module": "Tijd",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "snelheid",
      "subSkill": "snelheid_berekenen",
      "questionType": "fill_in",
      "question": "Een busschauffeur rijdt met 50 km/u. Hoe ver komt hij in 2 uur en 24 minuten?",
      "data": {
        "acceptedAnswers": ["120", "120 km"],
        "unit": "km",
        "placeholder": "... km"
      },
      "correctAnswer": "120",
      "conceptId": "distance_minutes_conversion",
      "variantIndex": 7,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.69,
      "stimulusAids": [
        {
          "type": "numberline", "showWhen": "always",
          "data": {
            "start": 0, "end": 150, "step": 50,
            "markers": [
              { "value": 0, "label": "0 uur" },
              { "value": 50, "label": "1 uur" },
              { "value": 100, "label": "2 uur" },
              { "value": 150, "label": "3 uur" }
            ],
            "label": "Afstand bij 50 km/u"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule", "showWhen": "wrong",
          "data": {
            "title": "Minuten omrekenen naar uren",
            "content": "Reken eerst de minuten om: 24 minuten = 24/60 = 0,4 uur. Dus 2 uur en 24 minuten = 2,4 uur. Afstand = snelheid × tijd = 50 × 2,4 = 120 km.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "De busschauffeur wil weten hoe ver hij komt. Eerst reken je de minuten om: 24 minuten ÷ 60 = 0,4 uur. De totale tijd is dus 2,4 uur. Dan: Afstand = Snelheid × Tijd = 50 × 2,4 = 120 km. Rekenstrategie: 50 × 2 = 100 en 50 × 0,4 = 20. Samen: 100 + 20 = 120 km. Controleer: 120 ÷ 50 = 2,4 uur ✓.",
        "solutionSteps": [
          "Schrijf de gegevens op: snelheid = 50 km/u, tijd = 2 uur en 24 minuten",
          "Reken minuten om: 24 ÷ 60 = 0,4 uur → totaal 2,4 uur",
          "Gebruik de formule: afstand = snelheid × tijd",
          "Reken uit: 50 × 2,4 = 120 km",
          "Controleer: 120 ÷ 50 = 2,4 uur ✓"
        ],
        "distractorExplanations": {}
      }
    },
    {
      "id": "TIJD-SNELHEID-008",
      "familyId": "TIJD-SNELHEID",
      "module": "Tijd",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "snelheid",
      "subSkill": "snelheid_berekenen",
      "questionType": "multiple_choice",
      "question": "Een wandelaar loopt 15 km in 3 uur. Een fietser fietst 40 km in 2 uur. Hoeveel km/u sneller is de fietser?",
      "options": ["15 km/u", "25 km/u", "20 km/u", "5 km/u"],
      "correctAnswer": 0,
      "conceptId": "speed_comparison",
      "variantIndex": 8,
      "citoDifficulty": 0.52,
      "citoDiscrimination": 0.68,
      "stimulusAids": [
        {
          "type": "numberline", "showWhen": "always",
          "data": {
            "start": 0, "end": 40, "step": 5,
            "markers": [
              { "value": 5, "label": "Wandelaar\n5 km/u" },
              { "value": 20, "label": "Fietser\n20 km/u" }
            ],
            "label": "Snelheidsvergelijking (km/u)"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule", "showWhen": "wrong",
          "data": {
            "title": "Snelheden vergelijken",
            "content": "Bereken eerst beide snelheden apart. Wandelaar: 15 ÷ 3 = 5 km/u. Fietser: 40 ÷ 2 = 20 km/u. Verschil: 20 − 5 = 15 km/u.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Om te vergelijken bereken je eerst beide snelheden. Wandelaar: 15 km ÷ 3 uur = 5 km/u. Fietser: 40 km ÷ 2 uur = 20 km/u. Het verschil is: 20 − 5 = 15 km/u. De fietser is dus 15 km/u sneller. Controleer: wandelaar 5 × 3 = 15 km ✓, fietser 20 × 2 = 40 km ✓.",
        "solutionSteps": [
          "Bereken snelheid wandelaar: 15 ÷ 3 = 5 km/u",
          "Bereken snelheid fietser: 40 ÷ 2 = 20 km/u",
          "Bereken het verschil: 20 − 5 = 15 km/u",
          "Controleer: 5 × 3 = 15 km ✓ en 20 × 2 = 40 km ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Wandelaar: 5 km/u, fietser: 20 km/u. Verschil: 20 − 5 = 15 km/u.",
          "1": "Je dacht waarschijnlijk dat je de afstanden aftrekt: 40 − 15 = 25 km. Maar je vergelijkt snelheden, niet afstanden. Bereken eerst beide snelheden apart en trek die van elkaar af. Onthoud: vergelijk altijd dezelfde eenheid (km/u).",
          "2": "Je hebt waarschijnlijk alleen de snelheid van de fietser berekend: 40 ÷ 2 = 20 km/u. Maar de vraag is hoeveel SNELLER de fietser is. Je moet het verschil berekenen: 20 − 5 = 15 km/u.",
          "3": "Je dacht waarschijnlijk dat je de tijden aftrekt: 3 − 2 = 1, en dan 5 × 1 = 5. Maar zo werkt het niet. Bereken beide snelheden apart: wandelaar 5 km/u, fietser 20 km/u. Verschil: 15 km/u."
        }
      }
    },
    {
      "id": "TIJD-SNELHEID-009",
      "familyId": "TIJD-SNELHEID",
      "module": "Tijd",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "snelheid",
      "subSkill": "snelheid_berekenen",
      "questionType": "multiple_choice",
      "question": "Een scooterrijder rijdt met 45 km/u. Hoeveel minuten doet hij over 15 km?",
      "options": ["20 minuten", "30 minuten", "15 minuten", "45 minuten"],
      "correctAnswer": 0,
      "conceptId": "time_result_in_minutes",
      "variantIndex": 9,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.69,
      "stimulusAids": [
        {
          "type": "numberline", "showWhen": "always",
          "data": {
            "start": 0, "end": 45, "step": 15,
            "markers": [
              { "value": 0, "label": "0 min" },
              { "value": 15, "label": "? min\n15 km" },
              { "value": 45, "label": "60 min\n45 km" }
            ],
            "label": "Route scooterrijder (45 km/u)"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule", "showWhen": "wrong",
          "data": {
            "title": "Tijd berekenen en omrekenen",
            "content": "Tijd = afstand ÷ snelheid = 15 ÷ 45 = 1/3 uur. Omrekenen: 1/3 × 60 = 20 minuten. Tip: 15 km is 1/3 van 45 km, dus het duurt 1/3 van 60 minuten.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "De scooterrijder wil weten hoeveel minuten hij over 15 km doet. Tijd = Afstand ÷ Snelheid = 15 ÷ 45 = 1/3 uur. Omrekenen naar minuten: 1/3 × 60 = 20 minuten. Je kunt het ook zo bedenken: bij 45 km/u rijdt hij 45 km in 60 minuten. 15 km is precies 1/3 van 45 km, dus het duurt 1/3 van 60 = 20 minuten. Controleer: 45 km/u × 1/3 uur = 15 km ✓.",
        "solutionSteps": [
          "Schrijf de gegevens op: snelheid = 45 km/u, afstand = 15 km",
          "Gebruik de formule: tijd = afstand ÷ snelheid",
          "Reken uit: 15 ÷ 45 = 1/3 uur",
          "Reken om naar minuten: 1/3 × 60 = 20 minuten",
          "Controleer: 45 × 1/3 = 15 km ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 15 ÷ 45 = 1/3 uur = 20 minuten.",
          "1": "Je dacht waarschijnlijk dat het een half uur duurt. Maar 15 km is 1/3 van 45 km (niet de helft). Dus het duurt 1/3 van 60 minuten = 20 minuten, niet 30. Onthoud: deel de afstand door de snelheid.",
          "2": "Je dacht waarschijnlijk dat het antwoord gelijk is aan de afstand: 15 km → 15 minuten. Maar km en minuten zijn verschillende eenheden. Onthoud: tijd = afstand ÷ snelheid = 15 ÷ 45 = 1/3 uur = 20 minuten.",
          "3": "Je dacht waarschijnlijk dat het antwoord gelijk is aan de snelheid: 45 km/u → 45 minuten. Maar de snelheid is niet hetzelfde als de reistijd. Onthoud: tijd = afstand ÷ snelheid."
        }
      }
    },
    {
      "id": "TIJD-SNELHEID-010",
      "familyId": "TIJD-SNELHEID",
      "module": "Tijd",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "snelheid",
      "subSkill": "snelheid_berekenen",
      "questionType": "matching",
      "question": "Koppel elke situatie aan de juiste snelheid.",
      "data": {
        "pairs": [
          { "left": "Wandelaar: 10 km in 2 uur", "right": "5 km/u" },
          { "left": "Fietser: 30 km in 1,5 uur", "right": "20 km/u" },
          { "left": "Auto: 210 km in 3 uur", "right": "70 km/u" },
          { "left": "Trein: 250 km in 2 uur", "right": "125 km/u" }
        ],
        "correctMatches": { "0": "0", "1": "1", "2": "2", "3": "3" }
      },
      "correctAnswer": { "0": "0", "1": "1", "2": "2", "3": "3" },
      "conceptId": "speed_matching_overview",
      "variantIndex": 10,
      "citoDifficulty": 0.43,
      "citoDiscrimination": 0.71,
      "stimulusAids": [
        {
          "type": "numberline", "showWhen": "always",
          "data": {
            "start": 0, "end": 130, "step": 10,
            "markers": [
              { "value": 5, "label": "Wandelaar\n5 km/u" },
              { "value": 20, "label": "Fietser\n20 km/u" },
              { "value": 70, "label": "Auto\n70 km/u" },
              { "value": 125, "label": "Trein\n125 km/u" }
            ],
            "label": "Snelheden vervoermiddelen"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule", "showWhen": "wrong",
          "data": {
            "title": "Snelheid = Afstand ÷ Tijd",
            "content": "Bereken elke snelheid apart: Wandelaar: 10 ÷ 2 = 5 km/u. Fietser: 30 ÷ 1,5 = 20 km/u. Auto: 210 ÷ 3 = 70 km/u. Trein: 250 ÷ 2 = 125 km/u.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Bij elke situatie gebruik je dezelfde formule: Snelheid = Afstand ÷ Tijd. Wandelaar: 10 ÷ 2 = 5 km/u. Fietser: 30 ÷ 1,5 = 20 km/u (tip: 30 ÷ 1,5 → × 2 = 60 ÷ 3 = 20). Auto: 210 ÷ 3 = 70 km/u. Trein: 250 ÷ 2 = 125 km/u. Merk op: hoe sneller het vervoermiddel, hoe meer km per uur.",
        "solutionSteps": [
          "Bereken elke snelheid: afstand ÷ tijd",
          "Wandelaar: 10 ÷ 2 = 5 km/u",
          "Fietser: 30 ÷ 1,5 = 20 km/u",
          "Auto: 210 ÷ 3 = 70 km/u",
          "Trein: 250 ÷ 2 = 125 km/u"
        ],
        "distractorExplanations": {}
      }
    }
  ]
}